export const DATADOG_LOG_CLIENT_TOKEN = "pubd3d59a4478ae4b468bb4f6a7c856a6cb"
